import React, { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { useLoaderData } from "react-router-dom";
import { createWarehouse, deleteWarehouse, getWarehouses, updateWarehouse } from "../../../data/loca/warehouses";
import { notify, send } from "../../../services/NotificationService";

export async function loader() {
    const warehouses = await getWarehouses();
    return { warehouses };
}

const emptyWarehouse = { id: null, name: "", address: "", zipcode: "", city: "" };

export default function WarehousesPage() {
    const { warehouses: initialWarehouses } = useLoaderData();
    const [warehouses, setWarehouses] = useState(initialWarehouses ?? []);
    const [form, setForm] = useState(emptyWarehouse);

    const onChange = (field, value) => setForm((current) => ({ ...current, [field]: value }));

    const onSubmit = async () => {
        if (!form.name || !form.city) {
            send("warning", "Le nom et la ville sont obligatoires.");
            notify();
            return;
        }

        const dto = { name: form.name, address: form.address, zipcode: form.zipcode, city: form.city };
        const saved = form.id ? await updateWarehouse(form.id, dto) : await createWarehouse(dto);
        const next = form.id
            ? warehouses.map((item) => item.id === saved.id ? saved : item)
            : [...warehouses, saved];
        setWarehouses(next.sort((a, b) => a.name.localeCompare(b.name)));
        setForm(emptyWarehouse);
        send("success", "Entrepôt enregistré.");
        notify();
    };

    const onEdit = (warehouse) => setForm({ ...warehouse });

    const onDelete = async (warehouse) => {
        await deleteWarehouse(warehouse.id);
        setWarehouses((current) => current.filter((item) => item.id !== warehouse.id));
        if (form.id === warehouse.id) setForm(emptyWarehouse);
        send("success", "Entrepôt supprimé.");
        notify();
    };

    return (
        <div>
            <h1>Gestion des entrepôts</h1>
            <Panel header={form.id ? "Modifier un entrepôt" : "Ajouter un entrepôt"}>
                <div className="contentForm">
                    <span className="p-float-label">
                        <InputText id="warehouse-name" value={form.name} onChange={(e) => onChange("name", e.target.value)} />
                        <label htmlFor="warehouse-name">Nom</label>
                    </span>
                    <span className="p-float-label">
                        <InputText id="warehouse-city" value={form.city} onChange={(e) => onChange("city", e.target.value)} />
                        <label htmlFor="warehouse-city">Ville</label>
                    </span>
                </div>
                <div className="contentForm">
                    <span className="p-float-label">
                        <InputText id="warehouse-address" value={form.address ?? ""} onChange={(e) => onChange("address", e.target.value)} />
                        <label htmlFor="warehouse-address">Adresse</label>
                    </span>
                    <span className="p-float-label">
                        <InputText id="warehouse-zipcode" value={form.zipcode ?? ""} onChange={(e) => onChange("zipcode", e.target.value)} />
                        <label htmlFor="warehouse-zipcode">Code postal</label>
                    </span>
                </div>
                <div className="contentForm">
                    <Button type="button" onClick={onSubmit}>{form.id ? "Mettre à jour" : "Ajouter"}</Button>
                    {form.id ? <Button type="button" severity="secondary" onClick={() => setForm(emptyWarehouse)}>Annuler</Button> : null}
                </div>
            </Panel>

            <Panel header="Mes entrepôts">
                {warehouses.length === 0 ? <p>Aucun entrepôt enregistré.</p> : warehouses.map((warehouse) => (
                    <div key={warehouse.id} className="card" style={{ marginBottom: 12 }}>
                        <div><b>{warehouse.name}</b></div>
                        <div>{warehouse.address || "Adresse non renseignée"}</div>
                        <div>{warehouse.zipcode || ""} {warehouse.city}</div>
                        <div className="contentForm">
                            <Button type="button" severity="secondary" onClick={() => onEdit(warehouse)}>Modifier</Button>
                            <Button type="button" severity="danger" onClick={() => onDelete(warehouse)}>Supprimer</Button>
                        </div>
                    </div>
                ))}
            </Panel>
        </div>
    );
}
